/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T16:56:48+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import EventListener from 'react-event-listener';
import keycode from 'keycode';
import OCalendarDatePicker from './OCalendarDatePicker';
import MDialog from 'common/dialogues/components/MDialog';
// import { MPopoverArrow } from './../../popovers'; // FIX: temporaryly disabled
import {LANDSCAPE, PORTRAIT} from './../constants/mode';
import {DIALOG, INLINE} from './../constants/container';

/**
 * ODatePickerDialog - …
 */
class ODatePickerDialog extends Component {
  /**
     * react lifecycle constructor() for <ODatePickerDialog>
     *
     * @param {object} props
     * @return {undefined}
     */
  constructor(props) {
    super(props);

    this.state = {
      open: !!props.open,
    };
  }

  /**
     * react render() <ODatePickerDialog>
     *
     * @return {object}
     */
  render() {
    const {
      autoOk,
      labelCancel,
      container,
      disableYearSelection,
      initialDate,
      firstDayOfWeek,
      maxDate,
      minDate,
      mode,
      labelOk,
      onAccept, // eslint-disable-line no-unused-vars
      onDismiss, // eslint-disable-line no-unused-vars
      onShow, // eslint-disable-line no-unused-vars
      shouldDisableDate,
      style, // eslint-disable-line no-unused-vars
      startWithYears,
      ...other
    } = this.props;

    const {open} = this.state;

    // const styles = {
    //     dialogContent: {
    //         width: mode === LANDSCAPE ? 479 : 310,
    //     },
    //     dialogBodyContent: {
    //         padding: 0,
    //         minHeight: mode === LANDSCAPE ? 330 : 434,
    //         minWidth: mode === LANDSCAPE ? 479 : 310,
    //     },
    // };

    const width = mode === LANDSCAPE ? 479 : 310;
    // const Container = (container === INLINE ? MPopoverArrow : MDialog);
    const Container = MDialog; // FIX: we ignore inline container
    const modeClass = mode === PORTRAIT ? 'portrait' : 'landscape';

    return (
      <div
        {...other}
        ref={this.refRoot}
        className={`o-date-picker o-date-picker-dialog ${modeClass}`}
      >
        <Container
          className={`o-date-picker-dialog__container ${modeClass}`} // For Dialog
          // trigger={this._rootNode} // For Popover
          width={width} // For Popover
          repositionOnUpdate // For Dialog
          autoScrollBodyContent // For Dialog
          open={open}
          onRequestClose={this.handleRequestClose}
        >
          <EventListener
            target="window"
            onKeyUp={this.handleWindowKeyUp}
          />
          <OCalendarDatePicker
            ref={this.refCalendar}
            autoOk={autoOk}
            labelCancel={labelCancel}
            labelOk={labelOk}
            disableYearSelection={disableYearSelection}
            firstDayOfWeek={firstDayOfWeek}
            initialDate={initialDate}
            maxDate={maxDate}
            minDate={minDate}
            mode={mode}
            open={open}
            shouldDisableDate={shouldDisableDate}
            onPressDay={this.handleOnPressDay}
            onPressCancel={this.handleOnPressCancel}
            onPressOk={this.handleOnPressOk}
            startWithYears={this.props.startWithYears}
          />
        </Container>
      </div>
    );
  }

    /**
     * @param {DOMNode} node
     */
    refRoot = (node) => {
      this._rootNode = node;
    }

    /**
     * @param {object} comp
     */
    refCalendar = (comp) => {
      this._calendarComp = comp;
    }

    handleOnPressDay = () => {
      if (this.props.autoOk) {
        setTimeout(this.handleOnPressOk, 300);
      }
    };

    handleOnPressCancel = () => {
      this.dismiss();
    };

    handleRequestClose = () => {
      this.dismiss();
    };

    handleOnPressOk = () => {
      if (this.props.onAccept && !this._calendarComp.isSelectedDateDisabled()) {
        this.props.onAccept(this._calendarComp.getSelectedDate());
      }

      this.setState({
        open: false,
      });
    };

    /**
     * @param {object} event
     */
    handleWindowKeyUp = (event) => {
      switch (keycode(event)) { // eslint-disable-line default-case
        case 'enter':
          this.handleOnPressOk();
          break;
      }
    };

    show = () => {
      if (this.props.onShow && !this.state.open) {
        this.props.onShow();
      }

      this.setState({
        open: true,
      });
    };

    dismiss = () => {
      if (this.props.onDismiss && this.state.open) {
        this.props.onDismiss();
      }

      this.setState({
        open: false,
      });
    };
}
ODatePickerDialog.propTypes = {
  autoOk: PropTypes.bool,
  labelCancel: PropTypes.node,
  labelOk: PropTypes.node,
  container: PropTypes.oneOf([DIALOG]),
  disableYearSelection: PropTypes.bool,
  firstDayOfWeek: PropTypes.number,
  initialDate: PropTypes.object,
  locale: PropTypes.string,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  mode: PropTypes.oneOf([PORTRAIT, LANDSCAPE]),
  onAccept: PropTypes.func,
  onDismiss: PropTypes.func,
  onShow: PropTypes.func,
  open: PropTypes.bool,
  shouldDisableDate: PropTypes.func,
  style: PropTypes.object,
};
ODatePickerDialog.defaultProps = {
  container: DIALOG,
  mode: PORTRAIT,
  labelCancel: 'Abbrechen',
  labelOk: 'Okay',
};
export default ODatePickerDialog;

